const baseUrl = 'https://us-central1-lockscreen-eb764.cloudfunctions.net';
const prodUrl = `${baseUrl}/rich_notifications/api/v2`;
const stageUrl = `${baseUrl}/stage_rich_notifications/api/v2`;

export const API = {
    production: {
        audience: `${prodUrl}/audience`,
        notification: `${prodUrl}/notification`,
        notificationMetrics: (id) => {
            return `${prodUrl}/notification/${id}/report`;
        },
        notificationReplies: (id) => {
            return `${prodUrl}/notification/${id}/replies`;
        },
        clientMetadata: `${prodUrl}/clientMetadata`,
        allUsers: `${prodUrl}/users`,
        deleteStaging: `${prodUrl}/staging`,
        imageUpload: `${prodUrl}/file/upload`,
        uploadedFiles: `${prodUrl}/files`
    },
    staging: {
        audience: `${stageUrl}/audience`,
        notification: `${stageUrl}/notification`,
        notificationMetrics: (id) => {
            return `${stageUrl}/notification/${id}/report`;
        },
        notificationReplies: (id) => {
            return `${stageUrl}/notification/${id}/replies`;
        },
        clientMetadata: `${stageUrl}/clientMetadata`,
        allUsers: `${stageUrl}/users`,
        deleteStaging: `${stageUrl}/staging`,
        imageUpload: `${stageUrl}/file/upload`,
        uploadedFiles: `${stageUrl}/files`
    }
}

const appIds = {
    comairfindlauncher: "com.airfind.launcher",
    comairfindrich_notifications_sdksample: "com.airfind.rich_notifications_sdk.sample",
    comairfindbrowser: "com.airfind.browser"
}

export const AppId = (appWithoutDots) => {
    return appIds[appWithoutDots] ? appIds[appWithoutDots] : appWithoutDots;
}

export const topics = (isStaging) => {
    if (isStaging) {
        return ['airfind-test', 'airfind-web-test'];
    }
    return ['airfind', 'airfind-web'];
}

export const Messages = {
    userPropertyWarning: " Notification will be sent to all users of the specified clientId, please input anything in the affiliateId, appId - it won't be considered."
}

export const urlRegex = (variable) => {
    return new RegExp('^(https://)([a-zA-Z0-9-.]+\.[a-zA-Z]{2,3})', 'i')
        .test(variable.trim());
};